import { RewardBalance } from "@factory/model/query-model-reward";
import { ScanMethod } from "@factory/model/scan-method.enum";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { toPng } from "html-to-image";
import html2pdf from "html2pdf.js";
import { useRef } from "react";

import PrintableCard from "./printable-card";

export function usePrintableCard() {
  const cardRef = useRef<HTMLDivElement>(null);
  const { showError } = useNotificationContext();

  const downloadPng = async (fileName: string) => {
    if (!cardRef.current) return;

    try {
      const dataUrl = await toPng(cardRef.current);
      const link = document.createElement("a");
      link.download = `${fileName}.png`;
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error("Download failed", err);
      showError(`Error: ${err}`);
    }
  };

  const downloadPdf = (fileName: string) => {
    if (!cardRef.current) return;

    const opt = {
      margin: 0.1,
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2, // Increase scale for better quality
        useCORS: true, // Enable CORS
        allowTaint: true, // Allow cross-origin images
        logging: true, // Enable logging for debugging
        imageTimeout: 15000, // Increase timeout
      },
      jsPDF: {
        unit: "px", // Use px to match exact rem size
        format: [272, 520], // width = 17rem = 272px, height = whatever fits
        orientation: "portrait",
      },
    };

    html2pdf().set(opt).from(cardRef.current).save();
  };

  const cardElement = (balance: RewardBalance, displayMode: ScanMethod) => (
    <div className="absolute left-[-9999px] top-0">
      <PrintableCard
        balanceData={balance}
        cardRef={cardRef}
        displayMode={displayMode}
      />
    </div>
  );

  return {
    downloadPng,
    downloadPdf,
    cardElement,
  };
}
